import { Injectable } from '@angular/core';
import * as Rx from 'rxjs/Rx';

@Injectable()
export class EventsService {
    listeners: Object;
    eventsSubject: any;
    events: any;

    constructor() {
        this.listeners = {};
        this.eventsSubject = new Rx.Subject();

        this.events = Rx.Observable.from(this.eventsSubject);

        this.events.subscribe(
            ({name, args}) => {
                if (this.listeners[name]) {
                    for (let listener of this.listeners[name]) {
                        listener(...args);
                    }
                }
            }
        );
    }

    on(name, listener) {
        if (!this.listeners[name]) {
            this.listeners[name] = [];
        }

        this.listeners[name].push(listener);

    }

    broadcast(name, ...args) {
        this.eventsSubject.next({
            name,
            args
        });
    }
    /**
     * Muliple Arguments to pass with event:
     * this.eventsService.broadcast('something', "Am I a?", "Should be b", "C?");
     *
     * this.eventsService.on('something', function (a, b, c) {
     *  console.log(a, b, c);
     * });
     */
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/events/events.service.ts